export const environment = {
    production: (window as any).env?.production,  
    apiServer: (window as any).env?.apiServer,
    oauthServerBaseUrl: (window as any).env?.oauthServerBaseUrl,
    clientSecret: (window as any).env?.clientSecret,
    clientId: (window as any).env?.clientId,
    oauthScope: (window as any).env?.oauthScope
};